// src/modules/competition/hooks/useCompetitionJoin.js
import { useState } from 'react';
import { useService } from '../../../shared/hooks/useService';

export const useCompetitionJoin = (competitionId) => {
    const [alert, setAlert] = useState({ show: false, variant: '', message: '' });
    const [showAlert, setShowAlert] = useState(false);
    const [showTeamModal, setShowTeamModal] = useState(false);
    const [teamActionLoading, setTeamActionLoading] = useState(false);
    const service = useService();

    const joinCompetition = async () => {
        try {
            await service.joinCompetition(competitionId);
            setAlert({ show: true, variant: 'success', message: 'Successfully joined the competition!' });
            setShowAlert(true);
            return true;
        } catch (error) {
            setAlert({ show: true, variant: 'danger', message: error.message });
            setShowAlert(true);
            return false;
        }
    };

    const openTeamModal = () => setShowTeamModal(true);
    const closeTeamModal = () => setShowTeamModal(false);

    const createTeam = async (teamName, onSuccess) => {
        setTeamActionLoading(true);
        try {
            await service.joinTeam(competitionId, 'create', { teamName });
            setShowTeamModal(false);
            setAlert({ show: true, variant: 'success', message: `Team "${teamName}" created and joined!` });
            setShowAlert(true);
            if (onSuccess) onSuccess();
            return true;
        } catch (error) {
            setAlert({ show: true, variant: 'danger', message: error.message });
            setShowAlert(true);
            return false;
        } finally {
            setTeamActionLoading(false);
        }
    };

    const joinTeam = async (teamId, onSuccess) => {
        setTeamActionLoading(true);
        try {
            await service.joinTeam(competitionId, 'join', { teamId });
            setShowTeamModal(false);
            setAlert({ show: true, variant: 'success', message: 'Successfully joined the team!' });
            setShowAlert(true);
            if (onSuccess) onSuccess();
            return true;
        } catch (error) {
            setAlert({ show: true, variant: 'danger', message: error.message });
            setShowAlert(true);
            return false;
        } finally {
            setTeamActionLoading(false);
        }
    };

    return {
        joinCompetition,
        alert,
        showAlert,
        setShowAlert,
        showTeamModal,
        openTeamModal,
        closeTeamModal,
        createTeam,
        joinTeam,
        teamActionLoading,
    };
};
